import type { TView } from '@alfa-bank/site-text-v2/src/models';

const view = 'primary-medium';

export interface IFontStyle {
    currency: TView;
    view: TView;
}

export const mobileConfig: IFontStyle = {
    currency: view,
    view: view,
};

export const desktopConfig: IFontStyle = {
    currency: view,
    view: 'accent-primary-medium',
};
